export const EAdminTab = {
  USERS: 'users',
  DIFFUSION_MODEL_UD: 'diffusion_model_ud',
  DIFFUSION_MODEL_HUGGING_FACE: 'diffusion_model_hugging_face',
  VPS: 'vps',
};
